export const PROFILE_INSIGHTS_LOADED = 'PROFILE_INSIGHTS_LOADED';

export const profileInsightsLoaded = () => ({
  type: PROFILE_INSIGHTS_LOADED,
});
